import { render, staticRenderFns } from "./p_recruit027.vue?vue&type=template&id=3199084b&scoped=true&"
import script from "./p_recruit027.vue?vue&type=script&lang=js&"
export * from "./p_recruit027.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3199084b",
  null
  
)

export default component.exports